import React from 'react';
import cx from 'classnames';

import { tabNavigatorContext } from './TabNavigatorContext';

export function Tab(props) {
  const { className, index, children } = props;

  const [activeIndex, setActiveIndex] = tabNavigatorContext();

  const linkClassName = cx('tab-list-item', className, { active: activeIndex === index });

  const onClickHandler = React.useCallback(() => {
    setActiveIndex(index);
  }, [index]);

  return (
    <div className={linkClassName} onClick={onClickHandler}>
      {children}
    </div>
  );
}
